import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-left" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </div>
      <div className="nav-right">
        <img src="/logo.png" alt="Logo" className="logo" />
        <span className="brand">Aflow</span>
      </div>
      {isOpen && (
        <div className="dropdown">
          <Link to="/" onClick={() => setIsOpen(false)}>Home</Link>
          <Link to="/how-it-works" onClick={() => setIsOpen(false)}>How It Works</Link>
          <Link to="/Info" onClick={() => setIsOpen(false)}>Pricing & Contact</Link> 
        </div>
      )}
    </nav>
  );
}

export default Navbar;
